const itemsDummy = [
  {
    id: 1,
    productName: "버그를 Java라 버그잡는 개리씨 키링 개발자키링 금속키링",
    price: 12500,
    stockCount: 100,
    thumbnailImg: "asset/img/1/thumbnailImg.jpg",
    option: [],
    discountRate: 0,
    shippingFee: 1500,
    detailInfoImage: ["asset/detail/2/detail1.png", "asset/detail/2/detail2.png"],
    viewCount: 0,
    pubDate: "2022-02-28",
    modDate: "2022-02-28",
  },
  {
    id: 2,
    productName: "우당탕탕 라이캣의 실험실 스티커 팩",
    price: 3500,
    stockCount: 1000,
    thumbnailImg: "asset/img/2/thumbnailImg.jpg",
    option: [],
    discountRate: 0,
    shippingFee: 1500,
    detailInfoImage: ["asset/detail/2/detail1.png", "asset/detail/2/detail2.png"],
    viewCount: 0,
    pubDate: "2022-02-28",
    modDate: "2022-02-28",
  },
  {
    id: 3,
    productName: "딥러닝 개발자 무릎 담요",
    price: 17500,
    stockCount: 0,
    thumbnailImg: "asset/img/3/thumbnailImg.jpg",
    option: [],
    discountRate: 0,
    shippingFee: 1500,
    detailInfoImage: [
      "asset/detail/3/detail1.png",
      "asset/detail/3/detail2.png",
      "asset/detail/3/detail3.png",
    ],
    viewCount: 0,
    pubDate: "2022-02-28",
    modDate: "2022-02-28",
  },
  {
    id: 4,
    productName: "네 개발잡니다 개발자키링 금속키링",
    price: 13500,
    stockCount: 100,
    thumbnailImg: "asset/img/4/thumbnailImg.jpg",
    option: [],
    discountRate: 0,
    shippingFee: 1500,
    detailInfoImage: ["asset/detail/4/detail1.png", "asset/detail/4/detail2.png"],
    viewCount: 0,
    pubDate: "2022-02-28",
    modDate: "2022-02-28",
  },
  {
    id: 5,
    productName: "Hack Your Life 개발자 노트북 파우치",
    price: 36000,
    stockCount: 230,
    thumbnailImg: "asset/img/5/thumbnailImg.jpg",
    option: [
      {
        id: 1,
        optionName: "13인치",
        additionalFee: 0,
      },
      {
        id: 2,
        optionName: "15인치",
        additionalFee: 1000,
      },
    ],
    discountRate: 19,
    shippingFee: 1500,
    detailInfoImage: ["asset/detail/5/detail1.png", "asset/detail/5/detail2.png"],
    viewCount: 0,
    pubDate: "2022-02-28",
    modDate: "2022-02-28",
  },
  {
    id: 6,
    productName: "[NEW] 위니브 개발자, 캐릭터 스티커팩 2종",
    price: 5500,
    stockCount: 1000,
    thumbnailImg: "asset/img/6/thumbnailImg.jpg",
    option: [
      {
        id: 1,
        optionName: "위니브 개발자 스티커팩",
        additionalFee: 0,
      },
      {
        id: 2,
        optionName: "위니브 프랜즈 스티커팩",
        additionalFee: 0,
      },
      {
        id: 3,
        optionName: "스티커팩 세트(개발자+프렌즈)",
        additionalFee: 5000,
      },
    ],
    discountRate: 0,
    shippingFee: 1500,
    detailInfoImage: [
      "asset/detail/6/detail1.png",
      "asset/detail/6/detail2.png",
      "asset/detail/6/detail3.png",
      "asset/detail/6/detail4.png",
      "asset/detail/6/detail5.png",
    ],
    viewCount: 0,
    pubDate: "2022-02-28",
    modDate: "2022-02-28",
  },
  {
    id: 7,
    productName: "제주코딩베이스캠프 코딩 연습장 세트",
    price: 8000,
    stockCount: 1000,
    thumbnailImg: "asset/img/7/thumbnailImg.jpg",
    option: [],
    discountRate: 0,
    shippingFee: 1500,
    detailInfoImage: ["asset/detail/7/detail1.png", "asset/detail/7/detail2.png"],
    viewCount: 0,
    pubDate: "2022-02-28",
    modDate: "2022-02-28",
  },
];

export default itemsDummy;
